import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {StoreModel} from "../../core/store/baseStore/interface";

interface StoreMapModel {
    enumStoreMap: {
        [key:string]: StoreModel
    }
}

const initialState:StoreMapModel = {
    enumStoreMap: {}
}

export const enumStoreMapSlice = createSlice({
    name: "enumStoreMap",
    initialState: initialState,
    reducers: {
        setStoreMap: (state, action: PayloadAction<{data:StoreModel, key: string}>) => {
            state.enumStoreMap[action.payload.key] =  action.payload.data
        },
        clearEnumMap: (state) => {
            state.enumStoreMap={};
        },
    }
})

export const { setStoreMap,clearEnumMap } = enumStoreMapSlice.actions;

export default enumStoreMapSlice.reducer;
